import { render, staticRenderFns } from "./NewCollection.vue?vue&type=template&id=6785ddce"
import script from "./NewCollection.vue?vue&type=script&lang=js"
export * from "./NewCollection.vue?vue&type=script&lang=js"
import style0 from "./NewCollection.vue?vue&type=style&index=0&id=6785ddce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports